export enum shells {
  NoShell = -1,
  ConfigHq,
  BizHq,
  AdminHq,
}
